var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "controls" }, [
      _c(
        "div",
        {
          staticClass: "shuffle",
          on: {
            click: function($event) {
              _vm.shuffle()
            }
          }
        },
        [_vm._v("S")]
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n\t\t\t" + _vm._s(_vm.size) + "\n\t\t\t"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.size,
              expression: "size"
            }
          ],
          staticClass: "size",
          attrs: { type: "range", min: "0.3", max: "1.2", step: "0.01" },
          domProps: { value: _vm.size },
          on: {
            __r: function($event) {
              _vm.size = $event.target.value
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "gallery" } },
      _vm._l(_vm.fileColorShuffled.slice(0, 100), function(fileColor) {
        return _c("div", {
          style: {
            width: _vm.size * 10 + "em",
            height: _vm.size * 20 + "em",
            margin: _vm.size * 5 + "em",
            backgroundImage:
              "url(img/bugs-small-marked-bgremoved/" + fileColor.file + ")"
          }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-957518ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-957518ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/masonary.grid.vue
// module id = 27
// module chunks = 0